export const setupPulots = () => {
  const pulots = document.querySelectorAll(".pulots");

  const magicValues = {
    pendulumSpeed: 0.01,
    maxOffset: 10,
    limit: 0.98,
    cosLike: 0.1
  };

  const objects = [];
  const maxDist = 30;
  const distK = 0.3;
  const cursor = { x: 0, y: 0 };

  function binaryRandom() {
    return Math.random() >= 0.5 ? 1 : -1;
  }

  function pendulum(position, direction, speedK) {
    // pendulum function for mobile movement
    let speed = Math.cos(Math.PI * position) * magicValues.cosLike;
    speed = ++speed / 2;
    speed *= magicValues.pendulumSpeed;
    speed *= speedK;
    if (speed === 0) speed = 0.001 * direction;
    position += direction * speed;
    if (position >= magicValues.limit) direction = -1;
    if (position <= -magicValues.limit) direction = 1;
    return { position, direction };
  }

  function initTarget() {
    // init values for mobile movements
    return {
      directions: [binaryRandom(), binaryRandom()],
      speeds: [1 + Math.random(), 1 + Math.random()],
      positions: [0, 0]
    };
  }

  function mobAnimate() {
    objects.forEach((object) => {
      for (let j = 0; j < 2; j++) {
        const values = pendulum(
          object.state.positions[j],
          object.state.directions[j],
          object.state.speeds[j]
        );
        object.state.positions[j] = values.position;
        object.state.directions[j] = values.direction;
      }
      object.mobMove.x = object.state.positions[0] * magicValues.maxOffset;
      object.mobMove.y = object.state.positions[1] * magicValues.maxOffset;
    });
  }

  function offset(el) {
    const rect = el.getBoundingClientRect();
    const scrollLeft =
      window.pageXOffset || document.documentElement.scrollLeft;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const width = Math.abs(rect.right - rect.left);
    const height = Math.abs(rect.bottom - rect.top);
    return {
      x: rect.left + scrollLeft + width / 2,
      y: rect.top + scrollTop + height / 2
    };
  }

  function vectorLength(x1, x2, y1, y2) {
    return Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
  }

  function move(object) {
    const angle = Math.atan2(cursor.x - object.x, -(cursor.y - object.y));
    let dist = vectorLength(cursor.x, object.x, cursor.y, object.y);
    dist *= distK;
    if (dist > maxDist) dist = maxDist;
    object.target.style.transform =
      "translate(" +
      (Math.sin(angle) * dist + object.mobMove.x) +
      "px, " +
      (-Math.cos(angle) * dist + object.mobMove.x) +
      "px)";
  }

  function moveAll() {
    objects.forEach(move);
  }

  function initObject(target) {
    const object = offset(target);
    object.target = target;
    object.mobMove = {
      x: 0,
      y: 0
    };
    object.state = initTarget();
    return object;
  }

  function mouseMoveEvent(e) {
    cursor.x = e.pageX;
    cursor.y = e.pageY;
  }

  function bothAnimate() {
    mobAnimate();
    moveAll();
    requestAnimationFrame(bothAnimate);
  }

  function setupAnimation() {
    if (document.body.classList.contains("body_no-touch")) {
      document.body.addEventListener("mousemove", mouseMoveEvent);
    } else {
      document.body.removeEventListener("mousemove", mouseMoveEvent);
    }
  }

  setupAnimation();

  window.addEventListener("resize", setupAnimation);

  pulots.forEach((pulot) => {
    const images = pulot.querySelectorAll(".pulots__image");
    let currentZ = 10;
    let resizeRequested = false;

    const galleryPlace = () => {
      images.forEach((image) => {
        objects.push(initObject(image));
      });

      resizeRequested = false;
    };

    const imagePlace = (image) => {
      image.style.zIndex = currentZ.toString();
      currentZ++;
    };

    images.forEach((image) => {
      image.addEventListener("click", () => {
        imagePlace(image);
      });
    });

    galleryPlace();

    window.addEventListener("resize", () => {
      if (resizeRequested) return;
      requestAnimationFrame(galleryPlace);
      resizeRequested = true;
    });
  });
  requestAnimationFrame(bothAnimate);
};
